import ManageAllPage from "@Quest/CorporateAttributes/Pages/ManageAllPage.vue";

export const routes = [
    {
        path: "/enterprise/attributes/:workspaceId/:strategyId",
        component: ManageAllPage
    },
]
